<template>
  <v-container fluid fill-height class="light-green primary">
    <v-layout row justify-center align-center>
      <v-flex xs12 sm8 md4 lg3>
        <img
          src="../assets/logotype-login.png"
          style="max-width: 75%; margin: 20px auto; display: block;"
        />
        <v-card>
          <v-alert v-if="errorMessage" :value="true" type="error">{{ errorMessage }}</v-alert>
          <form @submit.prevent="onSubmit">
            <v-card-text>
              <v-card-text>
                <v-text-field
                  v-model="email"
                  placeholder="Email"
                  :disabled="submitting"
                  type="email"
                  name="login"
                  required
                />

                <v-text-field
                  v-model="password"
                  placeholder="Password"
                  :disabled="submitting"
                  type="password"
                  name="password"
                  required
                />
              </v-card-text>
            </v-card-text>

            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" :loading="submitting" color="primary" flat>Login</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data: () => ({
    password: '',
    email: '',
  }),

  computed: {
    ...mapState({
      errorMessage: (state) => state.auth.errorMessage,
      submitting: (state) => state.auth.submitting,
      authorized: (state) => state.auth.authorized,
    }),
  },

  methods: {
    async onSubmit() {
      const { email, password } = this;
      await this.$store.dispatch('legacyLogin', { email, password });
      if (this.authorized) {
        this.$router.push(this.$router.currentRoute.query.next || '/');
      }
    },
  },
};
</script>
